import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import UploadCvtLogsModule from "../../components/modules/UploadCvtLogs/UploadCvtLogsModule";

const UploadCvtLogsPage = ({ user, isHideSideMenu }) => {
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace" />
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="MainteInfo shadow-xl bg-white rounded-lg overflow-hidden">
          <UploadCvtLogsModule
            user={user}
            showGeneralMessage={showGeneralMessage}
          />
        </div>
      </div>

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
    </div>
  );
};

export default UploadCvtLogsPage;